import React from 'react'
import { Stack, Table, Text } from '@mantine/core'
import { useTheme } from '../../../../components/ThemeProvider'

type Props = {
  data: any
}

const fields = [
  { label: '涉赌风险', key: 'bad_info_detail_score_B' },
  { label: '涉毒风险', key: 'bad_info_detail_score_C' },
  { label: '在逃风险', key: 'bad_info_detail_score_D' },
  { label: '涉案风险', key: 'bad_info_detail_score_E' },
  { label: '重点人员风险', key: 'bad_info_detail_score_F' },
  { label: '涉黑涉恐风险', key: 'bad_info_detail_score_G' },
]

const renderValue = (value: string, warningColor: string, primaryColor: string) => {
  const isRisk = value !== '0'
  return (
    <Text size="sm" fw={600} style={{ color: isRisk ? warningColor : primaryColor }}>
      {isRisk ? '存在风险' : '暂无风险'}
    </Text>
  )
}

export default function PriorityRiskTable({ data }: Props) {
  const theme = useTheme()

  return (
    <Stack gap="sm">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        重点风险扫描
      </Text>
      <Table
        highlightOnHover
        verticalSpacing="sm"
        withColumnBorders={false}
        styles={{
          table: { fontSize: '13px', tableLayout: 'fixed' },
          th: {
            backgroundColor: theme.surfaceMutedColor,
            color: theme.accentTextColor,
            whiteSpace: 'nowrap',
          },
        }}
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th style={{ width: '40%' }}>风险类型</Table.Th>
            <Table.Th style={{ width: '60%' }}>结果</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {fields.map((field) => (
            <Table.Tr key={field.key}>
              <Table.Td>{field.label}</Table.Td>
              <Table.Td>{renderValue(data?.[field.key], theme.warningColor, theme.primaryColor)}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Stack>
  )
}
